import {
  ContentAlignment,
  FullWidthTextComponent,
  FullWidthTextComponentTile,
  VxlFontStyle,
} from '@varo/graphql-schema-types';
import React, { ReactNode } from 'react';
import { TextProps } from 'react-native';
import { TextAlignment, VXLTextView } from 'shared/components/sdui/VXLText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { getVXLAlignment } from 'shared/utils/getVXLAlignment/getVXLAlignment';
import { getVXLColor } from 'shared/utils/getVXLColor/getVXLColor';

const overrideFontStyles: Partial<
  Record<VxlFontStyle, (props: TextProps) => React.JSX.Element | ReactNode>
> = {
  [VxlFontStyle.DisplayM]: TitleLgText,
  [VxlFontStyle.BodySBold]: BodySmBoldText,
  [VxlFontStyle.DisplayS]: TitleMdText,
  [VxlFontStyle.BodyXs]: BodyXSText,
  [VxlFontStyle.BodyBase]: BodyBaseText,
};

const VXLTextBorrowingPowerCompatibility = (
  element: FullWidthTextComponent | FullWidthTextComponentTile,
) => {
  const { text, textAlignment } = element;
  const { copy, style } = text;
  const { fontStyle } = style;

  const OverrideTextComponent = overrideFontStyles[fontStyle];
  if (OverrideTextComponent) {
    const vxlColor = getVXLColor(element.text.style.color);
    const vxlAlignment = getVXLAlignment(textAlignment);
    return (
      <OverrideTextComponent
        style={{
          color: vxlColor,
          alignContent: vxlAlignment,
          textAlign:
            TextAlignment[element.textAlignment ?? ContentAlignment.Leading],
        }}
      >
        {copy}
      </OverrideTextComponent>
    );
  }

  return <VXLTextView {...element} />;
};

export default VXLTextBorrowingPowerCompatibility;
